<template>
  <span>
    <v-btn
      fab
      x-small
      color="yellow"
      elevation="0"
      @click="openDialog"
    >
      <v-icon>mdi-square-edit-outline</v-icon>
    </v-btn>
    <v-dialog
      v-if="subjectObject"
      v-model="showDialog"
      max-width="400"
    >
      <v-card
        :loading="loading"
        :disabled="loading"
      >
        <v-card-title>ตั้งค่าห้องเรียน {{subjectObject.subject_id}}</v-card-title>
        <v-card-text>
          <h3 class="mb-10">{{subjectObject.subject_name_en}}</h3>
          <v-autocomplete
            label="อาคาร"
            v-model="building_no"
            :items="buildings"
            :item-text="item => item.building_name"
            :item-value="item => item.building_no"
          ></v-autocomplete>
          <v-autocomplete
            label="ห้องเรียน"
            v-model="room_no"
            :items="rooms"
            :item-text="item=> item.room_name"
            :item-value="item=> item.room_no"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="green white--text"
            @click="save"
          >บันทึก</v-btn>
          <v-btn
            class="gray"
            @click="showDialog = false"
          >ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import genericProvider from "@/services/generic.provider.js";
const genericService = new genericProvider();
import teachTableProvider from "@/services/config_teach_table.provider.js";
const teachTableService = new teachTableProvider();

export default {
  name: "BuildingDialog",
  props: {
    teach_table_id: {
      type: [String, Number],
      required: true,
    },
    subjectObject: {
      type: Object,
      required: true,
    },
    fetch_data: {
      type: Function,
      required: true,
    },
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      building_no: null,
      room_no: null,
      buildings: [],
      rooms: [],
    };
  },
  methods: {
    async fetchRooms(building_no, isLoading) {
      if(isLoading) {
        this.loading = true;
      }
      const rooms = await genericService.getRegistrarRoom(building_no);
      if (rooms.length > 0) {
        this.rooms = rooms;
      }
      if(isLoading) {
        this.loading = false;
      }
    },
    async openDialog() {
      this.loading = true;
      this.showDialog = true;
      const teach_table_id = this.subjectObject.teach_table_id;
      const building_info = await teachTableService.getBuildingFromTeachTable(
        teach_table_id,
        this.levelId
      );
      if (building_info.building_no) {
        this.building_no = building_info.building_no;
      }
      if (building_info.room_no) {
        this.room_no = building_info.room_no;
        this.fetchRooms(building_info.building_no);
      }
      const buildings = await genericService.getRegistrarBuilding();
      if (buildings.length > 0) {
        this.buildings = buildings;
      }
      this.loading = false;
    },
    async save() {
      console.log(this.teach_table_id);
      this.loading = true;
      await teachTableService.setBuildingFromTeachTable(
        this.teach_table_id,
        this.building_no,
        this.room_no,
        this.levelId
      );
      await this.fetch_data();
      this.loading = false;
      this.showDialog = false;
    },
  },
  watch: {
    building_no(newValue) {
      this.fetchRooms(newValue, true);
    },
  },
};
</script>

<style>
</style>
